import routerOptions0 from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.1_@types+node@18.19.101_db0@0.3.2_eslint@9.27.0_jiti@2._045bc9a16a17b62930e6526d584bd9bd/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/src/gmp-swa/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}